/**
 * src/pages/landing/BenefitList.tsx
 *
 * Benefit bullet list for LandingPage (IN-01: extracted to keep LandingPage under 200 lines).
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';
import { SERVICES_DB } from '@/entities/service/data/initialData';

export const BenefitList: FC = () => {
  const { t } = useTranslation();

  const benefits: string[] = [
    t('landing.benefit_1', 'Enter room dimensions — areas and perimeter calculated automatically'),
    t('landing.benefit_2', '{{count}}-service catalog with price sync — no manual entry', {
      count: SERVICES_DB.length,
    }),
    t('landing.benefit_3', 'Export estimates to Excel in kosztorys format, PLN/EUR'),
    t('landing.benefit_4', 'Works offline. Syncs across all devices on Pro plan'),
  ];

  return (
    <ul className="flex flex-col gap-3 text-left max-w-sm mx-auto w-full" role="list">
      {benefits.map((benefit, i) => (
        <li key={i} className="flex items-start gap-3">
          <CheckCircle2
            size={18}
            className="text-green-600 dark:text-green-400 shrink-0 mt-0.5"
            aria-hidden="true"
          />
          <span className="text-body text-slate-700 dark:text-slate-300">{benefit}</span>
        </li>
      ))}
    </ul>
  );
};
